<template>
<div>
  <v-data-table
      loading-text="Loading... Please wait"
      class="users-table"
      :headers="headersTimeReportsProject"
      :options.sync="paginationTimeReportsProject"
      :server-items-length="totalTimeReportsProject"
      :items-per-page-options="rowsPerPageReportsProject"
      :footer-props="footerOptionsTimeReportsProject"
      :items="timeReportsProject"
      :page.sync="currentPageTimeReportsProject"
      mobile-breakpoint="0"
  >
    <template v-slot:item.actions="{ item }">
      <v-tooltip top v-if="layout !== 'invoiceForm'">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click="showTimeReport(item.id)">
            <v-icon color="fontDefault">preview</v-icon>
          </v-btn>
        </template>
        <span>{{ languageData.preview }}</span>
      </v-tooltip>
      <v-tooltip top v-if="layout !== 'invoiceForm'">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              @click="showTimeReportsSummaryTableModal(item)"
              :disabled="item.isConfirmed"
              :class="{ 'before-confirm': !item.isConfirmed, 'after-confirm': item.isConfirmed }"
              icon>
            <v-icon color="fontDefault">summarize</v-icon>
          </v-btn>
        </template>
        <span>{{ languageData.labels.summary }}</span>
      </v-tooltip>
    </template>
  </v-data-table>
  
</div>
</template>

<script type="text/javascript">
import {mapActions, mapState} from "vuex";
import router from "../../../../../../router";
import eventBus from "../../../../../event-bus/eventBus";

export default {
  name: "TimeReportsRelation",
  props: {
    project: Object,
    layout: String,
  },
  data() {
    return {
      footerOptionsTimeReportsProject: {
        'items-per-page-options': [20, 50, 100],
        'disablePagination': false
      },
      currentPageTimeReportsProject: 1,
    }
  },
  methods: {
    ...mapActions("getHeadersTimeReportsProject", ["getHeadersTimeReportsProject"]),
    ...mapActions("getProjectTimeReports", ["getTimeReports"]),
    ...mapActions("updateVisibleTimeReportSummaryTableModal", ["updateVisibleTimeReportSummaryTableModal"]),
    ...mapActions("getHeadersTimeReportSummary", ["getHeadersTimeReportSummaryRequest"]),
    
    searchTimeReportsProject: function(valueSearch = {}, filters=false) {
      valueSearch.filters = filters;
      if (this.$route.name === 'ProjectsEdit') {
        const urlParams = new URLSearchParams(window.location.search);
        valueSearch.projectId = urlParams.get("id");
      } else if (this.project) {
        valueSearch.projectId = this.project.id;
      } 
      this.getTimeReports({ valueSearch });
      if(filters) {
        this.currentTimeReportsProject = 1;
      }
    },
    showTimeReport: function(id) {
      let r = router.resolve({ path: "/projects/time-reports/preview", query: { timeReportId: id } })
      window.location.assign(r.href)
    },
    showTimeReportsSummaryTableModal(timeReport) {
      this.getHeadersTimeReportSummaryRequest();
      this.updateVisibleTimeReportSummaryTableModal({
        isModalVisible: true,
        timeReport: timeReport,
      })
    }
  },
  computed: {
    ...mapState("getHeadersTimeReportsProject", {
      headersTimeReportsProject: state => state.headersTimeReportsProject
    }),
    ...mapState("getProjectTimeReports", {
      totalTimeReportsProject: state => state.pagination.totalItems,
      rowsPerPageReportsProject: state => state.pagination.rowsPerPage,
      timeReportsProject: state => state.dataReceive
    }),
    paginationTimeReportsProject: {
      set: function(value) {
        this.searchTimeReportsProject(value);
      },
      get: function() {
        return this.$store.state.getTimeReports.pagination;
      }
    },
  },
  mounted() {
    eventBus.$on("saveTimeReportSuccess", () => {
      this.searchTimeReportsProject();
    })
    eventBus.$on("setDisablePagination", (value) => {
      this.footerOptionsTimeReportsProject["disablePagination"] = value;
    });
    eventBus.$on("confirmTimeReportSummarySuccess", () => {
      if (this.$route.name === 'ProjectsEdit') {
        this.searchTimeReportsProject();
      }   
    })
  }
}
</script>